<script setup>
import { msalInstance, loginRequest } from "./msalConfig";
import { ref, onMounted } from "vue";

const account = ref(null);
const accessToken = ref("");

function login() {
  msalInstance.loginRedirect(loginRequest);
}

async function getToken() {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length === 0) {
    return login();
  }

  account.value = accounts[0];

  try {
    const response = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account: account.value,
    });
    accessToken.value = response.accessToken;
  } catch (error) {
    console.warn("Silent token failed, trying redirect:", error);
    msalInstance.acquireTokenRedirect({
      ...loginRequest,
      account: account.value,
    });
  }
}

onMounted(async () => {
  // 处理重定向回来时的响应
  const resp = await msalInstance.handleRedirectPromise();
  if (resp) {
    account.value = resp.account;
  } else {
    const currentAccounts = msalInstance.getAllAccounts();
    if (currentAccounts.length > 0) {
      account.value = currentAccounts[0];
    }
  }
});
</script>

<template>
  <div style="padding: 20px">
    <h2>O365 SAML + OAuth2 PKCE 登录 Demo</h2>

    <div v-if="!account">
      <button @click="login">登录</button>
    </div>

    <div v-else>
      <p>当前用户: {{ account.username }}</p>
      <button @click="getToken">获取 Access Token</button>
      <p v-if="accessToken"><b>Token:</b> {{ accessToken }}</p>
    </div>
  </div>
</template>
